import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ContrastTable } from './components/ContrastTable';
import { ProductPresentation } from './components/ProductPresentation';
import { ChaptersSection } from './components/ChaptersSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-cream text-neutral-800 font-sans selection:bg-brand-200 selection:text-brand-900" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainSection data-id="element-3" />
        <ContrastTable data-id="element-4" />
        <ProductPresentation data-id="element-5" />
        <ChaptersSection data-id="element-6" />
        <BonusSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FAQSection data-id="element-11" />
      </main>
      <SocialProofPopup data-id="element-12" />
    </div>;
}